import {type IntlShape} from 'react-intl';

import {GeneralInvitationErrorCode} from './invite_members_form/general_invitation_error_code';

export class GeneralInvitationError {
    public readonly code: GeneralInvitationErrorCode | 'unknown';

    constructor(code: GeneralInvitationErrorCode | 'unknown') {
        this.code = code;
    }

    getLocalizedMessage(intl: IntlShape) {
        switch (this.code) {
        case GeneralInvitationErrorCode.API_INSUFFICIENT_PERMISSIONS:
        case GeneralInvitationErrorCode.API_UNAVAILABLE_GUEST_PLUS_ROLE:
        case GeneralInvitationErrorCode.API_UNAVAILABLE_GUEST_ROLE:
            return intl.formatMessage({
                id: 'invite.members.error.failed_to_invite.title',
                defaultMessage: 'Failed to invite',
            });
        }

        return intl.formatMessage({
            id: 'invite.members.error.server_error.title',
            defaultMessage: 'Something went wrong',
        });
    }

    getLocalizedSecondaryMessage(intl: IntlShape) {
        switch (this.code) {
        case GeneralInvitationErrorCode.API_INSUFFICIENT_PERMISSIONS:
            return intl.formatMessage({
                id: 'invite.members.error.invalid_permissions.description',
                defaultMessage: "You don't have enough permissions to invite new members to the team",
            });

        case GeneralInvitationErrorCode.API_UNAVAILABLE_GUEST_PLUS_ROLE:
            return intl.formatMessage({
                id: 'invite.members.error.invite_guests.unavailable_role.description',
                defaultMessage: 'The Guest + role is no longer available in this workspace',
            });

        case GeneralInvitationErrorCode.API_UNAVAILABLE_GUEST_ROLE:
            return intl.formatMessage({
                id: 'invite.members.error.invite_restricted_guests.unavailable_role.description',
                defaultMessage: 'The Guest role is no longer available in this workspace',
            });
        }

        return intl.formatMessage({
            id: 'invite.members.error.server_error.description',
            defaultMessage: 'Try again later',
        });
    }
}
